import {Injectable, OnDestroy} from '@angular/core';
import {GlobalService} from '../global/global.service';
import {UserWsInfo} from './model/user-ws-info';
import {IssueChatUnreadWsStateService} from './issue-chat-unread-ws-state.service';
import {Permissions} from '../auth/permissions';
import {AuthStorage} from '../auth/auth-storage';
import {Module} from '../model/profile';
import {ReconnectingSocket} from './reconnecting-socket';

const isWebview = require('is-ua-webview');

const UNREAD_COUNT_TOPIC = `/users/issue-chat/unread-count`;

const RECONNECT_TIMEOUT = 60000;

@Injectable({
  providedIn: 'root'
})
export class IssueChatUnreadWebSocketService implements OnDestroy {

  private socket: ReconnectingSocket;

  constructor(private globalService: GlobalService,
              private issueChatUnreadWsStateService: IssueChatUnreadWsStateService) {

    this.socket = new ReconnectingSocket({
      hiddenReconnectDelay: RECONNECT_TIMEOUT,
      canConnect: () => Permissions.hasModule(Module.SERVICES)
        && AuthStorage.isLoggedClientEmployee()
        && !isWebview(navigator.userAgent),
      fetchUserInfo: () => this.globalService.userIssueChatWsInfo(),
      headers: (userInfo: UserWsInfo) => ({
        employeeId: userInfo.employeeId,
        clientId: userInfo.clientId,
        token: userInfo.token,
        accountId: userInfo.accountId
      }),
      onConnected: () => this.socket.subscribe(UNREAD_COUNT_TOPIC, (event) =>
        this.issueChatUnreadWsStateService.notifyCountByVehicle(JSON.parse(event.body))
      )
    });
  }

  public getUserAndConnect(): void {
    this.socket.connect();
  }

  public disconnect(): void {
    this.socket.disconnect();
  }

  public ngOnDestroy(): void {
    this.socket.destroy();
  }
}
